module.exports = __webpack_public_path__ + "static/media/live-in-care.44156606.jpeg";